import React from "react";
import { Link } from "react-router-dom";
import { Play, Star, Share2, Check } from "lucide-react";

export default function Welcome() {
  return (
    <div className="min-h-screen pt-28 pb-24 flex items-center justify-center px-6">
      <div className="w-full max-w-2xl space-y-10 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[color:var(--ns-accent)]/15 border border-[color:var(--ns-accent)]/40">
          <Check size={28} className="text-[color:var(--ns-accent)]" />
        </div>

        <div className="space-y-4">
          <div className="font-mono-mini text-[11px] uppercase tracking-[0.5em] text-[color:var(--ns-accent)]">
            Bienvenue
          </div>
          <h1 className="font-display text-4xl sm:text-6xl uppercase leading-[0.95]">
            Merci de vous être inscrit sur <span className="notranslate" translate="no">Kinebe</span>&nbsp;!
          </h1>
        </div>

        <div className="space-y-6 max-w-xl mx-auto">
          <p className="text-base sm:text-lg text-zinc-300 leading-relaxed">
            Profitez dès maintenant de vos <span className="text-white font-semibold">films, séries et fan&nbsp;films en 4K Ultra&nbsp;HD</span>,
            gratuitement et sans publicité.
          </p>
          <p className="text-base text-zinc-400 leading-relaxed">
            N&apos;hésitez pas à laisser un commentaire, à noter les productions que vous regardez
            et à partager <span className="notranslate" translate="no">Kinebe</span> autour de vous.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
          <Feature icon={<Play size={16} />} label="Explorer le catalogue" />
          <Feature icon={<Star size={16} />} label="Noter & commenter" />
          <Feature icon={<Share2 size={16} />} label="Partager autour de vous" />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-6">
          <Link
            to="/profiles"
            data-testid="welcome-browse-cta"
            className="inline-flex items-center gap-2 px-7 py-3 btn-accent rounded-full font-semibold text-sm uppercase tracking-widest"
          >
            <Play size={16} fill="currentColor" /> Choisir mon profil
          </Link>
          <Link
            to="/browse"
            data-testid="welcome-catalog-cta"
            className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 border border-white/15 hover:bg-white/15 rounded-full text-sm uppercase tracking-widest transition"
          >
            Parcourir le catalogue
          </Link>
        </div>
      </div>
    </div>
  );
}

function Feature({ icon, label }) {
  return (
    <div className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[color:var(--ns-card)] border border-white/10">
      <span className="text-[color:var(--ns-accent)]">{icon}</span>
      <span className="font-mono-mini text-[11px] uppercase tracking-widest text-zinc-200">
        {label}
      </span>
    </div>
  );
}
